"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePartialIUserDataEntity = void 0;
const partial_iuser_data_entity_default_filters_1 = require("./partial-iuser-data-entity-default-filters");
function parsePartialIUserDataEntity(data) {
    if (data.defaultFilters !== null && typeof data.defaultFilters === 'object')
        data.defaultFilters = (0, partial_iuser_data_entity_default_filters_1.parsePartialIUserDataEntityDefaultFilters)(data.defaultFilters);
    return data;
}
exports.parsePartialIUserDataEntity = parsePartialIUserDataEntity;
